import type { ContentBlock } from '@nimbus/types'

/**
 * The rich-text blocks format (Slate) wraps every inline link in mandatory empty
 * boundary text nodes. A list item containing a single link is therefore
 * stored as:
 *
 *   [ { type: 'text', text: '' }, { type: 'link', ... }, { type: 'text', text: '' } ]
 *
 * Our `Text` renderer turns an empty text node into a `<br>`. That is only the
 * desired behaviour for a genuinely empty paragraph (a block whose sole child
 * is an empty text node, used to render a blank line). When an empty text node
 * sits alongside other inline nodes it is just a spacer, and rendering it as a
 * `<br>` injects a stray line break before/after the content — which is exactly
 * what happened on the eligible-games lists where boundary nodes without a
 * modifier fell through to the `<br>` branch.
 *
 * This keeps an empty text node only when it is the sole node in the list,
 * dropping spacer text nodes that accompany other inline content.
 */
export const filterRenderableBlocks = (content: ContentBlock[]): ContentBlock[] => {
    if (content.length <= 1) {
        return content
    }

    return content.filter(node => !(node.type === 'text' && !node.text))
}
